import React, { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";


const initMessageCheckbox = (fb, data) => {
    const {appId, messengerAppId, pageId, customerId, uniqueUserRefId, checkBoxCallback } = data

    fb.init({
        appId: `${messengerAppId}`,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v6.0'
    });

    fb?.Event?.subscribe('messenger_checkbox', function (e) {
        if (e.event == 'rendered') {
            console.log('Plugin was rendered')
            checkBoxCallback?.("rendered");
        } else if (e.event == 'checkbox') {
            var checkboxState = e.state
            console.log('Checkbox state: ' + checkboxState)

            fb.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
                'app_id': messengerAppId,
                'page_id': pageId,
                'ref': 'facebook',
                'user_ref': uniqueUserRefId
            })
        } else if (e.event == 'not_you') {
            console.log('User clicked \'not you\'')
        } else if (e.event == 'hidden') {
            console.log('Plugin was hidden')
            checkBoxCallback?.("hidden");
        }

    })


    fb?.AppEvents.logPageView()
}


const loadFacebook = data => {
    const facebookSdk = document.getElementById('facebook-jssdk')

    if (!facebookSdk) {
        window.fbAsyncInit = function () {
            initMessageCheckbox(window?.FB, data)
        }

        const head = document.getElementsByTagName('head')[0]
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.id = 'facebook-sdk'
        script.text = `
                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) { return; }
                    js = d.createElement(s); js.id = id;
                    js.src = "https://connect.facebook.net/en_US/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));
        `
        head.appendChild(script)
    }else if(window.FB){
        initMessageCheckbox(window?.FB, data)
    }
}

export default props =>{
    const global = useSelector((state) => state.global);
    const { 
        customerId, 
        messengerSize = "standard", 
        checkBoxCallback
    } = props
    const { config } = global;
    const { pageId, messengerAppId } = config?.facebook;
    const [markup, setMarkup] = useState()

    
    useEffect(() => {
        if(customerId){
            let uniqueUserRefId = `${customerId}_${new Date().getTime()}`;
            loadFacebook({
                ...config?.facebook,
                customerId,
                uniqueUserRefId, 
                checkBoxCallback
            })
            setMarkup(`<div class="fb-messenger-checkbox" origin="${global?.config?.root}" messenger_app_id="${messengerAppId}" page_id="${pageId}" user_ref="${uniqueUserRefId}" size="${messengerSize}" allow_login="true" center_align="true" skin="light"></div>`);
        }
    }, [customerId])

    
    return <div dangerouslySetInnerHTML={{__html: markup}}/>
}